import type { FlotiqStore } from "@jti/fe-common";
import type { Product } from "@jti/magento";

export type StoreFilteringByAttributes = "" | "flavor_label" | "color_label" | "all";

export type StoreLocatorCartItemProp = Pick<Product, "categories" | "flavor_label" | "color_label" | "sku">;

export type StoreFiltersCategoriesEnabledParams = {
  isOpenNowFilterEnabled?: boolean;
  isProductTypesFilterEnabled?: boolean;
  isStoreServicesFilterEnabled?: boolean;
  isProductFlavoursFilterEnabled?: boolean;
  isProductFlavoursLYOFilterEnabled?: boolean;
  isProductColorsFilterEnabled?: boolean;
  isStoreTypeFilterEnabled?: boolean;
};

export type StoreLocatorFilterItem = {
  name: string;
  key: string;
  value?: string;
  label?: string;
  isLYO?: boolean;
};

export type StoreLocatorFilterCategory = {
  name: string;
  key: string;
  alternativeKeys?: string[];
  filters: StoreLocatorFilterItem[];
};

export type StoreLocatorFilter = StoreLocatorFilterCategory[];

export type StoreLocatorSelectedFilter = {
  category: string;
  key: string;
  selected: boolean;
};

export type StoreLocatorWithinCategoryFilterOperator = "and" | "or";

export type StoreLocatorPosition = { lat: number; lng: number };

export type StoreLocatorTranslationsFilter = {
  filterKey: string;
  translatedFilterKey: string;
};

export type Theme = "light" | "dark";

export type MobileDisplayType = "map" | "list";

export type StoreDetailsProductType = {
  key: string;
  is_available: string;
};

type ProductValue = {
  value: string | number;
};

export type ProductAttribute = {
  key: string;
  values?: ProductValue[];
  category?: string;
};

export type StoreIcons = {
  storeType: string;
  storeIcon: string;
};

export type StoreExtendedParams = {
  isOpeningHoursEnabled?: boolean;
  isOpeningHoursBreaksEnabled?: boolean;
  isStoreCardAddressEnabled?: boolean;
  isAvailableDevicesEnabled?: boolean;
  isAvailableSticksEnabled?: boolean;
  isMultiBrandSticksEnabled?: boolean;
  isMultipleFiltersSectionOpenEnabled?: boolean;
  defaultOpenedFilterCategory?: string;
  enabledFiltersCategories?: StoreFiltersCategoriesEnabledParams;
  searchAdditionalTitle?: string;
  isMapInteractionEnabled?: boolean;
  isInputExtraTextVisible?: boolean;
  isStoreTypeEnabled?: boolean;
  isAvailableServicesEnabled?: boolean;
  isGeneralAnnouncementEnabled?: boolean;
  isVendingMachineEnabled?: boolean;
  isVendingMachineTipEnabled?: boolean;
  isNearbyShopsEnabled?: boolean;
  isAsianAddressFormatEnabled?: boolean;
};

export type StoreLocatorProps = {
  defaultLat: string;
  defaultLng: string;
  activeStoreId?: string;
  filtersEnabled?: boolean;
  withinCategoryFilterOperator?: StoreLocatorWithinCategoryFilterOperator;
  isFiltersSharingEnabled?: boolean;
  isMapPositionFromUrlEnabled?: boolean;
  storeDetailsPage?: string;
  storeDetailsPageTarget?: "_blank" | "_self";
  filtersTranslations?: StoreLocatorTranslationsFilter[];
  filterByCartAvailabilityEnabled?: boolean;
  categoryAttributeFilter?: StoreFilteringByAttributes;
  cartItems?: StoreLocatorCartItemProp[];
  storesLimit?: number;
  defaultZoom?: number;
  flotiqApiKey?: string;
  flotiqContentType?: string;
  onChooseStore?: (store: FlotiqStore) => void;
  componentLevelLanguage?: string;
  defaultStoreIcon?: string;
  storeIcons?: StoreIcons[];
  isSearchVisible?: boolean;
  mapInactivityTimeout?: number;
} & StoreExtendedParams;

export type StoreDetailsDataProps = StoreExtendedParams & { store: FlotiqStore; defaultZoom?: number };
